import type { AuthUser } from '../auth/AuthContext';

export type TrackingModule = 'nutrition' | 'workouts' | 'sleep' | 'goals';

export type TrackingPrefs = {
  trackNutrition: boolean;
  trackWorkouts: boolean;
  trackSleep: boolean;
  trackGoals: boolean;
};

export type TrackingPrefField = keyof TrackingPrefs;

const TRACKING_FIELD_BY_MODULE: Record<TrackingModule, TrackingPrefField> = {
  nutrition: 'trackNutrition',
  workouts: 'trackWorkouts',
  sleep: 'trackSleep',
  goals: 'trackGoals',
};

export function trackingFieldForModule(module: TrackingModule): TrackingPrefField {
  return TRACKING_FIELD_BY_MODULE[module];
}

export function trackingPrefsFromUser(user: AuthUser | null): TrackingPrefs {
  return {
    trackNutrition: user?.trackNutrition !== false,
    trackWorkouts: user?.trackWorkouts !== false,
    trackSleep: user?.trackSleep !== false,
    trackGoals: user?.trackGoals !== false,
  };
}

export function isModuleEnabled(user: AuthUser | null, module: TrackingModule): boolean {
  const p = trackingPrefsFromUser(user);
  switch (module) {
    case 'nutrition':
      return p.trackNutrition;
    case 'workouts':
      return p.trackWorkouts;
    case 'sleep':
      return p.trackSleep;
    case 'goals':
      return p.trackGoals;
  }
}

export const TRACKING_MODULE_LABELS: Record<TrackingModule, { title: string; description: string }> = {
  nutrition: {
    title: 'Nutrition',
    description: 'Meals, macros, water, and calorie targets',
  },
  workouts: {
    title: 'Workouts',
    description: 'Training log, programs, and strength history',
  },
  sleep: {
    title: 'Sleep',
    description: 'Sleep hours and bed/wake times',
  },
  goals: {
    title: 'Goals',
    description: 'Weight, strength, and body-composition targets',
  },
};
